import type { ReactElement } from 'react';
import { cloneElement, useId } from 'react';

type Props = {
  className?: string;
  color?: string | ReactElement<{ id?: string }>;
  style?: React.CSSProperties;
  width?: number;
  height?: number;
};

export const StarBall = ({
  className,
  color = 'var(--c-onBase-primary)',
  style,
  width = 34,
  height = 34,
}: Props) => {
  const gradientId = useId();
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 107 107"
      fill={typeof color === 'string' ? color : `url(#${gradientId})`}
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      {typeof color === 'object' && cloneElement(color, { id: gradientId })}
      <path d="M53.35 0C23.88 0 0 23.88 0 53.35C0 82.82 23.88 106.7 53.35 106.7C82.82 106.7 106.7 82.8 106.7 53.35C106.7 23.9 82.82 0 53.35 0ZM53.35 90.82C32.65 90.82 15.89 74.05 15.89 53.36C15.89 32.67 32.67 15.89 53.35 15.89C74.03 15.89 90.81 32.66 90.81 53.35C90.81 74.04 74.04 90.81 53.35 90.81V90.82ZM49.35 30.36C49.23 30.23 49.09 30.11 48.91 30.05C48.73 29.99 48.56 29.99 48.38 30.02C48.2 30.06 48.04 30.15 47.91 30.27C47.78 30.4 47.69 30.56 47.65 30.74C46.56 35.21 44.39 39.33 41.33 42.78C38.27 46.22 34.44 48.88 30.14 50.49C29.96 50.55 29.82 50.67 29.71 50.81C29.61 50.94 29.53 51.13 29.52 51.31C29.52 51.49 29.52 51.68 29.62 51.84C29.71 52 29.83 52.13 29.97 52.24C33.86 54.65 37.14 57.98 39.47 61.95C41.81 65.92 43.13 70.38 43.36 74.96C43.36 75.14 43.43 75.31 43.54 75.46C43.64 75.61 43.79 75.72 43.95 75.8C44.13 75.87 44.3 75.9 44.48 75.87C44.66 75.86 44.83 75.77 44.96 75.65C48.47 72.68 52.66 70.6 57.15 69.6C61.64 68.6 66.32 68.72 70.75 69.94C70.93 69.98 71.12 69.98 71.28 69.94C71.46 69.88 71.62 69.79 71.74 69.65C71.86 69.52 71.95 69.36 71.98 69.17C72.01 68.99 71.98 68.8 71.92 68.64C70.17 64.39 69.51 59.77 69.94 55.2C70.38 50.63 71.92 46.23 74.45 42.38C74.55 42.22 74.61 42.04 74.61 41.85C74.61 41.66 74.57 41.48 74.48 41.32C74.38 41.16 74.24 41.03 74.07 40.95C73.89 40.86 73.72 40.83 73.54 40.85C68.96 41.19 64.36 40.39 60.14 38.57C55.92 36.73 52.22 33.9 49.34 30.33V30.36H49.35Z" />
    </svg>
  );
};
